import { Reveal, Eyebrow } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "A tailored approach",
    text: "Every lesson is designed around you: your level, your goals, your pace. One-on-one instruction where every minute counts — never a one-size-fits-all program.",
  },
  {
    n: "02",
    title: "French rigor",
    text: "A structured French as a Foreign Language (FLE) method, taught by a native Parisian. Grammar, vocabulary and culture progress together, with high standards and clarity.",
  },
  {
    n: "03",
    title: "The joy of learning",
    text: "We progress when we love learning. Lively conversation, cultural discoveries and constant encouragement: confidence comes naturally.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-24 lg:py-36" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Eyebrow>The Atelier manifesto</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-2xl leading-tight">
            Learn French, <span className="italic text-gold">the Parisian way.</span>
          </h2>
        </Reveal>
        <div className="mt-20">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="grid md:grid-cols-12 gap-6 md:gap-12 py-12 border-t border-sand items-start" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="md:col-span-2 font-serif text-5xl lg:text-6xl text-gold/70">{c.n}</span>
                <h3 className="md:col-span-4 font-serif text-2xl lg:text-3xl">{c.title}</h3>
                <p className="md:col-span-6 text-navy/70 leading-relaxed text-base">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
